export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_a01e9057-9358-42ee-8997-40e79fc5f7e1/artifacts/4rt9wsn3_ChatGPT%20Image%2028%20mar%202026%2C%2017_05_08.png";

export const WHATSAPP_URL = "https://wa.me/393294646429";
export const WHATSAPP_NUMBER = "+39 329 464 6429";
export const CONTACT_EMAIL = "infoteamrpf@gmail.com";
export const INSTAGRAM_URL =
    "https://www.instagram.com/rpf_coaching_?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==";
export const APP_GOOGLE =
    "https://play.google.com/store/apps/details?id=com.mrcoachingapp.app&pcampaignid=web_share";
export const APP_APPLE =
    "https://apps.apple.com/it/app/mrcoaching-app/id6757755200";

export const COACHPLUS_URL =
    "https://storefront.coachplus.app/sf/manuel-romano";

export const MAPS_URL = "https://maps.app.goo.gl/qwJ3o9bZyUWTJTbC7";
export const ADDRESS = "Via Alessandro Manzoni 204/A, San Giorgio a Cremano (NA)";

export const COACH_IG = {
    manuel:
        "https://www.instagram.com/manuelromano_coach?igsh=MTRoMjV6ZWR3dXlwaA%3D%3D&utm_source=qr",
    beniamino:
        "https://www.instagram.com/beniamino.femiano?igsh=amZoOXE4djJ6ZmVt",
    enrico:
        "https://www.instagram.com/decayo_sw?igsh=ZW4xNTJ2azJjc2Ru",
};

export const P_IVA = "10965231219";

export const IMAGES = {
    hero: "https://images.pexels.com/photos/29392546/pexels-photo-29392546.jpeg",
    gym: "https://images.pexels.com/photos/11338008/pexels-photo-11338008.jpeg",
    calisthenics: "https://images.unsplash.com/photo-1591504771093-591b5e2afca0",
    nutrition: "https://images.pexels.com/photos/842571/pexels-photo-842571.jpeg",
    studio: "https://images.pexels.com/photos/8874414/pexels-photo-8874414.jpeg",
};

// Coach logos (converted from HEIC)
export const COACH_LOGOS = {
    manuel: "/brand/manuel.jpeg",
    beniamino: "/brand/beniamino.png",
    enrico: "/brand/enrico.png",
};

export const PACKAGE_IMAGES = {
    basic: "/brand/basic.jpeg",
    completo: "/brand/completo.png",
    hybrid: "/brand/hybrid.png",
};

export const APP_GRAPHIC = "/brand/app-graphic.png";

// 11 micro-services shown as grid
import {
    Dumbbell,
    Video,
    Smartphone,
    Apple,
    ClipboardCheck,
    Clock,
    Laptop,
    Ruler,
    CreditCard,
    Users as UsersIcon,
    Activity,
} from "lucide-react";

export const SERVICES = [
    {
        id: "pt",
        name: "Personal Training 1:1",
        text: "Allenamento uno-a-uno in sala con il coach, totalmente personalizzato.",
        icon: Dumbbell,
    },
    {
        id: "consulenza",
        name: "Consulenza online",
        text: "Prima analisi completa online per inquadrare obiettivi e piano d'azione.",
        icon: Video,
    },
    {
        id: "app",
        name: "App personalizzata",
        text: "La tua scheda, progressi e feedback sempre in tasca con l'app MR Coaching.",
        icon: Smartphone,
    },
    {
        id: "nutri-consiglio",
        name: "Consiglio nutrizionale",
        text: "Linee guida pratiche e sostenibili per allenarti e mangiare bene.",
        icon: Apple,
    },
    {
        id: "checkin",
        name: "Check-in in presenza",
        text: "Valutazioni periodiche dal vivo per monitorare ogni progresso reale.",
        icon: ClipboardCheck,
    },
    {
        id: "supporto",
        name: "Supporto H24",
        text: "Rispondo personalmente 24 ore su 24. Qualsiasi dubbio, qualsiasi momento.",
        icon: Clock,
    },
    {
        id: "online",
        name: "Coaching online",
        text: "Programmi completi da seguire ovunque: palestra, casa, viaggio.",
        icon: Laptop,
    },
    {
        id: "antro",
        name: "Antropometria",
        text: "Rilevazioni corporee complete per costruire dati oggettivi sul tuo percorso.",
        icon: Ruler,
    },
    {
        id: "rate",
        name: "Pagamenti flessibili",
        text: "Possibilità di pagamento a rate: carta, bonifico, contanti.",
        icon: CreditCard,
    },
    {
        id: "nutri-collab",
        name: "Nutrizionista in collaborazione",
        text: "Piano alimentare ufficiale gestito da Beniamino Femiano, dedicato al team.",
        icon: UsersIcon,
    },
    {
        id: "bia",
        name: "Test BIA inclusi",
        text: "Analisi della composizione corporea (massa magra, grassa, idratazione).",
        icon: Activity,
    },
];

export const METHOD_STEPS = [
    {
        n: "01",
        title: "Consulenza in studio",
        text: "Partiamo di persona: analizziamo obiettivi, storia sportiva e misurazioni di base.",
    },
    {
        n: "02",
        title: "Test BIA & antropometria",
        text: "Rilevazione completa della composizione corporea per avere dati oggettivi da cui partire.",
    },
    {
        n: "03",
        title: "Piano + app custom",
        text: "Ricevi allenamento e indicazioni direttamente dentro l'app MR Coaching, gestita da me.",
    },
    {
        n: "04",
        title: "Check-in & supporto H24",
        text: "Controlli periodici dal vivo e supporto diretto 7/7 per aggiustare ogni settimana.",
    },
];

export const TEAM = [
    {
        name: "Manuel Romano",
        role: "Founder & Head Coach",
        bio: "Founder di RPF Coaching. Personal trainer e coach di bodybuilding, dedica la sua vita all'allenamento e al trasformare risultati in realtà concreta per i clienti.",
        logo: COACH_LOGOS.manuel,
        instagram: "https://www.instagram.com/manuelromano_coach?igsh=MTRoMjV6ZWR3dXlwaA%3D%3D&utm_source=qr",
        igHandle: "@manuelromano_coach",
    },
    {
        name: "Beniamino Femiano",
        role: "Nutrizionista in collaborazione",
        bio: "Responsabile del reparto nutrizione. Crea piani alimentari personalizzati, sostenibili ed efficaci per ogni obiettivo sportivo del team RPF.",
        logo: COACH_LOGOS.beniamino,
        instagram: "https://www.instagram.com/beniamino.femiano?igsh=amZoOXE4djJ6ZmVt",
        igHandle: "@beniamino.femiano",
    },
    {
        name: "Enrico Pinto",
        role: "Calisthenics Coach",
        bio: "Coach specializzato in calisthenics. Ti accompagna dalle prime skill fino ai movimenti più avanzati, con un approccio tecnico e pratico.",
        logo: COACH_LOGOS.enrico,
        instagram: "https://www.instagram.com/decayo_sw?igsh=ZW4xNTJ2azJjc2Ru",
        igHandle: "@decayo_sw",
    },
];

export const PACKAGES = [
    {
        id: "basic",
        name: "Basic",
        tagline: "Solo allenamento in sala",
        price: 40,
        coach: "Manuel Romano",
        image: PACKAGE_IMAGES.basic,
        bullets: [
            "Personal training 1:1 con Manuel",
            "Scheda e app personalizzata",
            "Supporto diretto H24",
            "Check-in in presenza + BIA",
        ],
        highlight: false,
    },
    {
        id: "completo",
        name: "Pacchetto Completo",
        tagline: "Sala + Nutrizione",
        price: 65,
        coach: "Manuel Romano × Beniamino Femiano",
        image: PACKAGE_IMAGES.completo,
        bullets: [
            "Tutto incluso nel pacchetto Basic",
            "Piano alimentare personalizzato",
            "Gestione nutrizionale dedicata",
            "Aggiornamenti continui su dati BIA",
        ],
        highlight: true,
    },
    {
        id: "hybrid",
        name: "Hybrid Strength",
        tagline: "Calisthenics + Sala Pesi",
        price: 45,
        coach: "Manuel Romano × Enrico Pinto",
        image: PACKAGE_IMAGES.hybrid,
        bullets: [
            "Tutto incluso nel pacchetto Basic",
            "Programmazione ibrida sala + calisthenics",
            "Apprendimento nuove skill",
            "Coach dedicato per ogni disciplina",
        ],
        highlight: false,
    },
];

export const TESTIMONIALS = [
    {
        name: "Francesca Chianese",
        text: "Personal trainer professionale e sempre disponibile. Si mette a disposizione operativamente 24 ore su 24 per fornire consigli sia sull'allenamento in palestra sia sull'alimentazione, dimostrando grande competenza e attenzione alle esigenze individuali. Dispone di una propria app personale, da lui gestita, completa e ben organizzata. Un servizio serio e di alto livello.",
    },
    {
        name: "Domenico Murolo",
        text: "Ho iniziato ad allenarmi con Manuel da un po' di tempo e sono rimasto davvero colpito. Ha solo 18 anni, ma è un ragazzo serio, intraprendente e molto professionale. Mi scrive praticamente ogni giorno per sapere come sto, come vanno gli allenamenti. Questo tipo di attenzione è raro. Se cercate qualcuno di motivato, presente e che vi segua davvero, ve lo consiglio assolutamente.",
    },
    {
        name: "Luigi Boggia",
        text: "Mi alleno con Manuel da quasi un anno e sono molto soddisfatto di aver intrapreso questo percorso. Non è solo un ragazzo preparato, ma una persona capace di ascoltare e adattare il percorso alle mie reali esigenze. In questi mesi ho visto il mio corpo cambiare, ma la vittoria più grande è la consapevolezza. Se cercate qualcuno che vi guidi con serietà e passione, Manuel è la persona giusta.",
    },
    {
        name: "Alessandro Cotta",
        text: "È da qualche mese che mi sono affidato al coach Romano per cambiare il mio aspetto fisico. Subito dopo il primo mese ho riscontrato i primi risultati con l'aumento del peso e della massa muscolare grazie all'allenamento che lui mi ha prescritto. Consiglio istantaneamente di sceglierlo per avere subito i primi risultati del suo lavoro.",
    },
    {
        name: "Fabiana Chianese",
        text: "Un coach professionale e competente. Fin dal primo giorno ha capito i miei obiettivi e ha costruito un programma su misura per me, spiegando ogni esercizio in modo chiaro. Ci sono stati molti progressi e adesso mi alleno con più sicurezza.",
    },
    {
        name: "Matteo Palomba",
        text: "Ottimo coach, professionale e sempre puntuale. Sono riuscito finalmente ad avere dei risultati concreti, per un ottimo prezzo. Lo consiglierei per chi vuole iniziare un percorso in palestra.",
    },
    {
        name: "Francesco Scarparo",
        text: "Grande professionalità nonostante la giovane età. Molto empatico e comprensivo.",
    },
    {
        name: "Francesco Cinquegrana",
        text: "Coach serio e disponibile 24h su 24 per supporto tecnico e morale.",
    },
];
